export const SET_WEBAPI = "setWebApi";
export const CLEAR_API_STORAGE = "clearApiStorage";
